export default {
  INIT: 'POS_PAY_LINK/INIT',
  UPDATE_DATA: 'POS_PAY_LINK/UPDATE_DATA',
  UPDATE_META: 'POS_PAY_LINK/UPDATE_META',
  UPDATE_PARAMS: 'POS_PAY_LINK/UPDATE_PARAMS',
}
